@if (securitiesDropDown) {
  <p-dropdown
    [options]="securitiesDropDown.items"
    [(ngModel)]="altSecuritySymbol"
    (onChange)="onSecurityChange()"
    optionLabel="name"
    class="alt-security-dropdown"
    styleClass="ui-button-alt-security-info">
  </p-dropdown>
}
